import { WebSocketSubject } from 'rxjs/webSocket'

import { Message } from '@mmocld/message'

export class SimulatorInstance {
  ws?: WebSocketSubject<Message>
  messagesReceived = 0
}
